import { Navigate, useLocation } from "react-router-dom";

interface AdminRouteProps {
  children: React.ReactNode;
}

const hasToken = (): boolean => {
  try {
    return Boolean(localStorage.getItem("accessToken"));
  } catch {
    return false;
  }
};

/**
 * Schützt Admin-Routen. Prüft zuerst, ob überhaupt eine Anmeldung vorliegt
 * (sonst Redirect zum Login), danach das Admin-Flag.
 *
 * Wichtig: Dies ist nur eine clientseitige UX-Absicherung für die Navigation.
 * Die tatsächliche Autorisierung erzwingt das Backend über [Authorize(Roles="Admin")]
 * je Endpunkt – ein manipuliertes localStorage-"isAdmin" verschafft keinen
 * Zugriff auf Admin-Daten, sondern führt serverseitig zu 401/403.
 */
const AdminRoute = ({ children }: AdminRouteProps) => {
  const location = useLocation();

  // 1. Ohne Anmeldung zum Login (nicht zur Patientenseite, die ebenfalls Auth braucht).
  if (!hasToken()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // 2. Angemeldet, aber kein Admin → zurück zur Patientenseite.
  const isAdmin = (() => {
    try {
      return localStorage.getItem("isAdmin") === "true";
    } catch {
      return false;
    }
  })();

  if (!isAdmin) {
    return <Navigate to="/patients" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
